


















import { Vue, Prop, Component } from 'vue-property-decorator';
import type { DocumentAttachment } from '@getaccept/lib-shared/src/types/document-attachment';
import type { SigningTheme } from '@getaccept/lib-shared/src/signing-theme/types/theme';
import DocumentAttachmentItem from './DocumentAttachmentItem.vue';

@Component({
  components: {
    DocumentAttachmentItem,
  },
})
export default class DocumentAttachments extends Vue {
  @Prop() documentAttachments!: DocumentAttachment[];
  @Prop() focusedRequiredId?: string;
  @Prop() theme: SigningTheme;
  @Prop() uploadingAttachmentIds: string[];
  @Prop() isSigned: boolean;
  @Prop() isPreview!: boolean;

  handleUploadAttachment(payload: { attachmentId: string; name: string }) {
    this.$emit('uploadFile', payload);
  }

  handleAttachmentView(id: string) {
    this.$emit('attachmentView', id);
  }

  isUploading(attachmentId: string): boolean {
    return this.uploadingAttachmentIds.includes(attachmentId);
  }
}
